import React, { useState } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Header from "../Components/Header";
import GetTokenController from "../../Controller/GetTokenController";
import CreateArticle from "../../Controller/CreateArticle";

const CreateArticleView = () => {
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [date, setDate] = useState('');
    const [images, setImages] = useState([]);
    const [createAttempt, setCreateAttempt] = useState(false);

    const handlecreate = (event) => {
        event.preventDefault();

        const currentDate = date || new Date().toISOString().split('T')[0];

        console.log(images);
        

        setCreateAttempt(true);

        return <CreateArticle title={title} content={content} date={currentDate} images={images} />;
    };

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files); // Convert FileList to Array
        const imageBlobs = [];

        files.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                imageBlobs.push(reader.result); // Store image as base64
                if (imageBlobs.length === files.length) {
                    setImages((prevImages) => [...prevImages, ...imageBlobs]); // Add all images once loaded
                }
            };
            reader.readAsDataURL(file);
        });
    };

    return (
        <>
            <Header title="Creation d'article" />
            <h1 className='text-white text-center mb-5'>Connexion</h1>
            <Form className='text-black' onSubmit={handlecreate}>
                <Form.Group className="mb-3" controlId="formBasicUsername">
                    <Form.Label>Titre</Form.Label>
                    <Form.Control
                        className='mb-5'
                        type="text"
                        placeholder="Titre de l'article"
                        onChange={(e) => setTitle(e.target.value)}
                        required
                    />
                </Form.Group>

                <Form.Group className="mb-5" controlId="formBasicContent">
                    <Form.Label>Contenu de l'article</Form.Label>
                    <Form.Control
                        as="textarea" // Change to textarea
                        rows={5} // Optional: define rows for textarea
                        placeholder="L'article"
                        onChange={(e) => setContent(e.target.value)}
                        required
                    />
                </Form.Group>
                <Form.Group className="mb-5" controlId="formBasicDate">
                    <Form.Label>Date de l'article</Form.Label>
                    <Form.Control
                        type="date"
                        placeholder="Date de l'article"
                        onChange={(e) => setDate(e.target.value)}
                    />
                </Form.Group>
                <Form.Group className="mb-5" controlId="formBasicImages">
                    <Form.Label>Ajouter des images</Form.Label>
                    <Form.Control
                        type="file"
                        accept="image/*"
                        multiple // Allow multiple file selection
                        onChange={handleImageChange}
                    />
                </Form.Group>
                <div className='text-center mt-5 mb-3'>
                    <Button className='mb-4' size="lg" variant="secondary" type="submit">
                        Créer l'article
                    </Button>
                </div>
            </Form>
            {createAttempt && (
                <CreateArticle title={title} content={content} date={date || new Date().toISOString().split('T')[0]} images={images} />
            )}
        </>
    );
};

export default CreateArticleView;